const state = {
  bookPurchaseId: null,
  bookBanner: false,
  bookInfo: null,
};

const getters = {

};

const actions = {
};

const mutations = {
  SetBookInfo(state, data) {
    state.bookInfo = data;
  },
  SetBookPurchaseId(state, data) {
    state.bookPurchaseId = data;
  },
  SetBookBanner(state, data) {
    state.bookBanner = data;
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};
